import React, { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../button';
import IntervalInput, { IntervalInputProps } from './interval-input';

import './intervals-list-input.scss';

export type IntervalListInputEntry = {
  id: IntervalInputProps['id'];
  name: IntervalInputProps['name'];
  max?: IntervalInputProps['max'];
};

export type IntervalsListInputProps = {
  entries: IntervalListInputEntry[];
  disabled?: boolean;
  onAdd: () => void;
  onDelete: (id: string) => void;
};

const MIN = 0;

const IntervalsListInput = memo(({
  entries,
  onDelete,
  onAdd,
  disabled = false,
}: IntervalsListInputProps) => {
  const { t } = useTranslation();

  const options = useMemo(() => {
    return [{
      label: t('common:minutes'),
      value: 'minutes'
    }, {
      label: t('common:hours'),
      value: 'hours'
    }, {
      label: t('common:days'),
      value: 'days'
    }];
  }, [t]);

  return (
    <div className="IntervalsListInput">
      {
        entries.map((entry) => (
          <IntervalInput
            {...entry}
            key={`IntervalsListInput-${entry.id}`}
            min={MIN}
            options={options}
            onDelete={onDelete}
            disabled={disabled}
          />
        ))
      }
      {
        !disabled && (
          <Button icon="add" onClick={() => onAdd()}>
            { t('common:add_notification') }
          </Button>
        )
      }
    </div>
  );
});

export default IntervalsListInput;
